<template>
    <v-card class="background-create_wait_qt-card" v-resize="onResize" v-if="isReady">
        <v-card-title v-if="windowSize.x > 600" class="font-theme d-flex justify-space-between pa-0">
            <span
                style="font-weight: 400; font-size: calc(100% + 1.4vw); margin: 1.2% 0% 1.2% 2.8%; line-height: 45px; font-family: 'Sarabun', 'sans-serif';"
                class="text-center">
                Waiting QT
            </span>
            <span style="margin: 3.2% 3.2% 3.2% 0%;">
                <v-btn rounded class="btn-data-table-wait-qt" elevation="1" outlined
                    style="margin-left: 10px; height:40px; width:120px" @click="ConfirmWaitingQT('SaveCsToPo')">
                    <v-icon color="#139ad4" style="margin-right:3px;">
                        mdi-information-outline
                    </v-icon>
                    บันทึก
                </v-btn>
                <v-btn rounded color="#0B68D6" class="white--text btn-data-table-wait-qt" elevation="1" 
                    style="margin-left: 10px; height:40px; width:120px" @click="ConfirmWaitingQT('RunPo')">
                    <v-icon color="#ffffff" style="margin-right:3px;">
                        mdi-export
                    </v-icon>
                    RUN PO
                </v-btn>
            </span>
        </v-card-title>
        <v-card-title v-else class="font-theme d-flex pa-1" style="border-bottom: 1px solid #BCB9B9;">
            <v-row no-gutters class="font-theme standard-row d-flex justify-space-between"
                style="padding: 3.8% 3.2% 2% 0%; line-height: 47px;">
                <v-col cols="11" sm="">
                    <span style="font-weight: 200; font-family: 'Sarabun'; font-size: calc(100% + 1.5vw);">Waiting QT</span>
                </v-col>
                <v-col cols="1" sm="auto">
                    <v-menu offset-y transition="scroll-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="#414040">
                                <v-icon size="30">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="background-color: #414040;">
                            <v-list-item dense @click="ConfirmWaitingQT('SaveCsToPo')">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text"
                                        style="font-size: 16px; line-height: 25px;">บันทึก</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense @click="ConfirmWaitingQT('RunPo')">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text"
                                        style="font-size: 16px; line-height: 25px;">RUN PO</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
        </v-card-title>
        <v-row no-gutters class="standard-row font-theme" style="padding: 0% 1.2% 1.8% 1.2%;">
            <v-data-table 
            :headers="headers" 
            :items="groupedData" 
            fixed-header 
            disable-sort
            :item-value="item => `${item._id}`" 
            item-key="_id" 
            :group-by="groupField"
            class="elevation-0 data-item-create-wait-qt-table" 
            style="width: 100%;" 
            :options.sync="optionsTransaction"
            :server-items-length="countTransaction"
            :footer-props="{'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text':'จำนวนแถวต่อหน้า'}"
            mobile-breakpoint="1001"
            dense
            >
                <template v-if="CsTransaction.length < 20" v-slot:[`body.append`]="{ isMobile }">
                    <tr v-for="(_, index_tr) in (20 - CsTransaction.length)" :key="`tr__${index_tr}`" v-show="!isMobile">
                        <td v-for="(_, index_td) in 12" :key="`td__${index_td}`"></td>
                    </tr>
                </template>
                <!-- <template slot="no-data">
                    <a class="text-center d-flex justify-center black--text" style="font-size: 16px;">
                        ไม่พบข้อมูล
                    </a>
                </template> -->
                <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                </template>
                <template v-slot:[`group.header`]="{ group, isOpen, toggle }">
                    <th style="width: 16px;">{{ group }}</th>
                    <th style="text-align: left;">
                        <v-icon @click="toggle">{{ isOpen ? 'mdi-menu-up' : 'mdi-menu-down' }}
                        </v-icon>
                    </th>
                    <th colspan="6"></th>
                    <th>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" align=center>
                                    <svg xmlns="http://www.w3.org/2000/svg" style="color:#7f7d7d;" width="22" height="22"
                                        fill="currentColor" class="bi bi-file-earmark-fill" viewBox="0 0 16 16">
                                        <path
                                            d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z" />
                                    </svg>
                                </v-btn>
                            </template>
                            <span class="font-theme">ดูเอกสาร</span>
                        </v-tooltip>
                    </th>
                    <th colspan="2"></th>
                    <th>
                        <v-checkbox v-model="selectedGroups[group]" @change="groupCheckboxChanged(group)" color="#00AA1B"
                            on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank"></v-checkbox>
                    </th>
                </template>
                <template v-slot:[`item.so_number`]="{ item }">
                    {{ item.so_number || '–' }}
                </template>
                <template v-slot:[`item.document_id`]="{ item }">
                    {{ item.document_id || '–' }}
                </template>
                <template v-slot:[`item.job_status`]="{ item }">
                    {{ item.job_status || '–' }}
                </template>
                <template v-slot:[`item.group_service`]="{ item }">
                    {{ item.group_service || '–' }}
                </template>
                <template v-slot:[`item.service_name`]="{ item }">
                    {{ item.service_name || '–' }}
                </template>
                <template v-slot:[`item.unit`]="{ item }">
                    {{ item.unitFormatted || '–' }}
                </template>
                <template v-slot:[`item.unit_type`]="{ item }">
                    {{ item.unit_typeFormatted || '–' }}
                </template>
                <template v-slot:[`item.actual`]="{ item }">
                    {{ item.actualFormatted || '–' }}
                </template>
                <template v-slot:[`item.file`]="{ item }">
                    {{ item.file || '' }}
                </template>
                <template v-slot:[`item.qt_value`]="{ item }">
                    <v-text-field align="center" v-model="item.qt_value" @input="subGroupCheckboxChanged(item)" outlined dense hide-details :rules=[rules.number]></v-text-field>
                </template><template v-slot:[`item.qt_vendor`]="{ item }">
                    <v-text-field align="center" v-model="item.qt_vendor" @input="subGroupCheckboxChanged(item)" outlined dense hide-details></v-text-field>
                </template><template v-slot:[`item.action`]="{ item }">
                    <v-checkbox v-model="selectedItem[item._id]" @change="subGroupCheckboxChanged(item)" color="#00AA1B"
                        on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank">
                    </v-checkbox>
                </template>
            </v-data-table>
        </v-row>
        <div>
            <ConfirmWaitingQT ref="confirmDialog" />
        </div>
    </v-card>
</template>

<script>
import ConfirmWaitingQT from '../components/ConfirmWaitingQT.vue';
import { MainFunction } from '@/functions/mainFunction.js'
import { EventBus } from '../EventBus'
export default {
    components: {
        ConfirmWaitingQT,
    },
    data: () => ({

        optionsTransaction: {
            "page": 1,
            "itemsPerPage": 20
        },
        trigRowPerPage: false,
        countItem: 0,
        headers: [
            { text: "Sale Document", align: "center", value: "sale_document", width: "8%" },
            { text: 'Document ID', align: "center", value: 'document_id' },
            { text: 'Job Status', align: "center", value: 'job_status' },
            { text: 'Group Service', align: "center", value: 'group_service' },
            { text: 'Service Name', align: "center", value: 'service_name' },
            { text: 'Unit', align: "center", value: 'unit' },
            { text: 'Unit Type', align: "center", value: 'unit_type' },
            { text: 'Actual', align: "center", value: 'actual' },
            { text: 'File', align: "center", value: 'file' },
            { text: 'QT Vendor', align: "center", value: 'qt_vendor' },
            { text: 'QT Value', align: "center", value: 'qt_value' },
            { text: "", align: "center", value: "action" },
        ],
        isOpenMap: {},
        selected:{},
        expanded: [],
        isReady: true,
        windowSize: { x: 0, y: 0 },
        memoTransaction: [],
        callApiPending: 0,
        groupField: 'so_number',
        selectedItemsConfirm: [],
        selectedHeader: [],
        selectedItems: [],
        selectedItem: {},
        selectedGroups: {},
        CsTransaction: [],
        countTransaction: 0,
        loading: true,
        rules: {
            required: value => !!value || 'Required.',
            number: value => {
                const pattern = /^\d+(\.\d+)*$/
                return pattern.test(value) || 'Invalid value.'
            },
        },
    }),
    mounted() {
        this.onResize()
        // this.processCsTransaction()
        this.getTransaction()
    },
    watch: {
        "optionsTransaction.page"() {
            this.getAllItem()
            this.trigRowPerPage = true
        },
        "optionsTransaction.itemsPerPage"() {
            if (!this.trigRowPerPage) {
                this.optionsTransaction.page = 1
                this.getAllItem()
            }
        },
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {
                EventBus.$emit('loadingState', false)
            }
        }
    },
    computed: {
        groupedData() {
            // Flatten the nested data structure
            const flatData = this.CsTransaction.reduce((acc, curr) => {
                return [...acc, ...curr.cs_list.map(item => ({
                    ...item, so_number: curr.so_number,
                    actualFormatted: MainFunction.addComma(parseFloat(item.actual.replace(/,/g, '').trim()) || 0),
                    unitFormatted: MainFunction.addComma(parseFloat(item.unit.replace(/,/g, '').trim()) || 0),
                    unit_typeFormatted: MainFunction.addComma(parseFloat(item.unit_type.replace(/,/g, '').trim()) || 0),
                }))];
            }, []);
            return flatData;
        }
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        processCsTransaction() {
            // Flatten CsTransaction data for the table
            const memoTransaction = [];
            this.CsTransaction.forEach((document) => {
                Object.keys(document).forEach((saleDocument) => {
                    this.memoTransaction.push(...document[saleDocument]);
                });
            });
            console.log(this.memoTransaction)
            return memoTransaction
        },
        toggleGroup(Sale_Document) {
            this.$set(this.isOpenMap, Sale_Document, !this.isOpenMap[Sale_Document]);
            console.log(this.isOpenMap)
        },
        groupCheckboxChanged(group) {
            this.selectedItemsConfirm = []
            // Handle changes in group checkboxes
            const groupItems = this.groupedData.filter(item => item.so_number === group);
            if (this.selectedGroups[group]) {
                groupItems.forEach(item => {
                    this.$set(this.selectedItem, item._id, {
                        ...item,
                        checkbox: true,
                    });
                });
            } else {
                groupItems.forEach(item => {
                    this.$delete(this.selectedItem, item._id);
                });
            }
            for (const [key, value] of Object.entries(this.selectedItem)) {
                this.selectedItemsConfirm.push(value)
            }
        },
        subGroupCheckboxChanged(subgroup) {
            this.selectedItemsConfirm = []
            const subgroupItems = this.groupedData.filter(item => item._id == subgroup._id)
            if (this.selectedItem[subgroup._id]) {
                subgroupItems.forEach(item => {
                    this.$set(this.selectedItem, item._id, {
                        ...item,
                        checkbox: true,
                        qt_vendor: item.qt_vendor || "",
                        qt_value: item.qt_value || ""
                    });
                })
            } else {
                this.selectedGroups[subgroup.sale_document] = false
                subgroupItems.forEach(item => {
                    this.$delete(this.selectedItem, item._id);
                })
            }
            for (const [key,value] of Object.entries(this.selectedItem)){
                this.selectedItemsConfirm.push(value)
            }
        },
        alert(title = '', text = 'Fail', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text: text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            });
        },
        async getTransaction() {
            // if (!this.myPermission.length) {
            //     return this.alert('ไม่พบสิทธิ์การเข้าถึง', 'Warning', 'info')
            // }
            try {
                this.callApiPending++
                const countTransactions = {
                    baseURL: this.$api_url,
                    url: `/cs_to_po/api/v1/count_waiting_qt`,
                    method: 'GET'
                }
                const searchTransactions = {
                    baseURL: this.$api_url,url: `/cs_to_po/api/v1/get_waiting_qt?limit=${this.optionsTransaction.itemsPerPage || 20}&page=${this.optionsTransaction.page || 1}`,
                    method: 'GET'
                }
                const data = await Promise.all([this.axios(countTransactions), this.axios(searchTransactions)])
                this.countTransaction = data[0].data.data
                this.CsTransaction = data[1].data.data
                $(".data-item-create-wait-qt-table.v-data-table > .v-data-table__wrapper").scrollTop(0)
            } catch (error) {
                this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
                console.log(error)
            } finally {
                this.callApiPending--
                this.isChangeTab = false
                this.trigRowPerPage = false
                if (!this.callApiPending) {
                    this.isReady = true
                }
            }
        },
        ConfirmWaitingQT(action) {
            this.action = action;
            if (!this.selectedItemsConfirm || this.selectedItemsConfirm.length === 0) {
                this.alert('กรุณาเลือกรายการก่อนยืนยัน', 'Warning', 'info');
                return;
            }
            if((action == 'SaveCsToPo' || action == 'RunPo') && !this.allAreEqual(this.selectedItemsConfirm)){
                this.alert('กรุณาเลือกรายการที่มีข้อมูลวันที่เริ่มต้น - วันที่สิ้นสุดและ QT vendor ตรงกัน', 'Warning', 'info');
                return
            }
            this.$refs.confirmDialog.open(this.selectedItemsConfirm, action);
        },
        allAreEqual(array) {
            const result = array.every(element => {
                if (element.p_so_04 === array[0].p_so_04 && element.p_so_05 === array[0].p_so_05 && element.qt_vendor === array[0].qt_vendor) {
                    return true;
                }
            });
            return result;
        }
    }
}
</script>

<style>
.background-create_wait_qt-card {
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
    margin: 60px 4.51% 56px 4.51% !important;
    border-radius: 23px !important;
}

.data-item-create-wait-qt-table thead th {
    height: 39px !important;
    background-color: #333333 !important;
    color: #FFFFFF !important;
    font-size: 20px;
}

.data-item-create-wait-qt-table thead th:first-child {
    border-radius: 10px 0 0 0;
}

.data-item-create-wait-qt-table thead th:last-child {
    border-radius: 0 10px 0 0;
}

.data-item-create-wait-qt-table thead th {
    font-size: 13px !important;
    font-weight: 400;
}

.data-item-create-wait-qt-table.v-data-table--fixed-header>.v-data-table__wrapper>table>thead>tr>th {
    position: sticky;
    top: 0;
    z-index: 2;
}

.data-item-create-wait-qt-table .v-data-table__wrapper table tbody tr td {
    padding-top: 0px;
    height: 49px !important;
    font-size: 12px;
}

.data-item-create-wait-qt-table tbody tr td {
    border-left: 0px solid #D8D5D5 !important;
    border-right: 0px solid #D8D5D5 !important;
    border-bottom: 0px !important;

}

.data-item-create-wait-qt-table tbody tr td:first-child {
    border-left: 0px !important;
    border-right: 0px solid #D8D5D5 !important;
    border-bottom: 0px !important;
}

.data-item-create-wait-qt-table tbody tr td:last-child {
    border-left: 1px solid #D8D5D5 !important;
    border-right: 0px !important;
    border-bottom: 0px !important;
}

.data-item-create-wait-qt-table tbody tr:nth-of-type(even) {
    background: #F8F5F5;
}

.data-item-create-wait-qt-table .v-data-table__wrapper table tbody tr td {
    border-left: none !important;
}

.data-item-create-wait-qt-table.v-data-table>.v-data-table__wrapper {
    height: calc(100vh - 174px);
    overflow: auto;
    scroll-behavior: smooth;
}

.data-item-create-wait-qt-table.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent !important;
}

.data-item-create-wait-qt-table.v-data-table>.v-data-table__wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent !important;
}

.data-item-create-wait-qt-table.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #F8F5F5;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table>.v-data-table__wrapper>table>thead>tr>th,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>th {
    padding: 0 10px;
    transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}

.btn-data-table-wait-qt {
    font-weight: 500;
    font-size: 12px;
    border: 1px solid #000000 !important;
    border-radius: 20px;
}

@media only screen and (max-width: 599px) {
    .data-item-table-setting tbody tr td:first-child {
        border-top: 1px solid #D8D5D5 !important;
        border-left: 1px solid #D8D5D5 !important;
    }

    .data-item-table-setting tbody tr td:last-child {
        border-right: 1px solid #D8D5D5 !important;
        border-bottom: 1px solid #D8D5D5 !important;
    }

    .data-item-create-wait-qt-table .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td {
        width: 100vw;
        border-right: none !important;
        border-bottom: none !important;
    }

    .data-item-table-setting td.large-only, .data-item-table-setting td[colspan="3"] {
        display: none;
    }

    .data-item-table-setting td.large-only, .data-item-table-setting td[colspan="5"] {
        display: table-cell;
    }


}
</style>
